import cn from "classnames"

import { MenuOutlined } from "@/icons"

import styles from "./NameCell.module.scss"

import type { NameCellProps } from "./NameCell.types"

export const NameCell: React.FC<NameCellProps> = ({
  children,
  disabled,
  setActivatorNodeRef,
  ...listeners
}) => {
  const { key, props } = children || {}
  const { render, record } = props || {}
  const renderChild = !!key && !!render && !!record

  return (
    <div data-testid="name-cell-dragging-row" className={styles.container}>
      <MenuOutlined
        ref={setActivatorNodeRef}
        className={cn(styles.icon, disabled && styles.disabled)}
        data-testid="icon-name-cell"
        {...listeners}
      />
      {renderChild && render(record[key], record)}
    </div>
  )
}
